<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode, animated: false, fadeIn: true }">
    <!-- 유정 및 체적환산 관리 --------------------------------------------------------------------------------------------->

      <BCard header-tag="header" footer-tag="footer">
        <div slot="header">
          <BIconFileRuledFill/> <strong> 탱크 테이블 설정 </strong>
          <div class="card-header-actions">
            <small class="text-muted">탱크 테이블을 구성하고 탱크별 온도별 환산 체적비율를 조회합니다.</small>
          </div>
        </div>

        <BRow>
          <BCol xl="6">

            <CCard border-color="info" style="min-height:500px">
              <CCardHeader>
                <BRow>
                  <BCol>
                    <BIconTable/> 탱크 테이블
                  </BCol>

                  <BCol>
                    <CSelect size="sm" class="mb-0"
                             :value.sync="selectedStatus"
                             @change="changeTid"
                             :options="statusOpts"
                    />
                  </BCol>

                  <BCol class="float-right">
                    <CSelect size="sm" class="mb-0"
                             :value.sync="tid"
                             :state="!tid"
                             @change="changeTid"
                             :options="tankOpts"
                      />

                  </BCol>

                   <!-- 새로고침 버튼 추가 -->
                  <BCol class="float-right">
                    <BButton size="sm" variant="primary" @click="refreshPage">
                      <BIconArrowRepeat/>
                    </BButton>
                  </BCol>

                </BRow>
              </CCardHeader>

              <CCardBody>

                <tank-table-list
                  :tid="tid"
                  :status="selectedStatus"
                  :key="tableKey"
                />

              </CCardBody>
            </CCard>

          </BCol>
          <BCol xl="6">
            <CCard border-color="info" style="min-height:500px">
              <CCardHeader>
                <BRow>
                  <BCol>
                    <BIconTable/> 온도별 체적 환산표
                  </BCol>
                  <BCol class="text-right" v-if="tid">
                    <BButton size="sm" variant="primary"
                             :disabled="!tid"
                             @click="getOilTempTable">
                      <BIconFileEarmarkSpreadsheetFill/>
                      [{{tid}}] {{tnm}} 체적 환산표 조회
                    </BButton>
                  </BCol>

                </BRow>
              </CCardHeader>

              <CCardBody>
                <oil-temp-table ref="oilTempTable" :tid="tid" :group-index="groupIndex" :key="oilTempKey"/>
              </CCardBody>
            </CCard>



          </BCol>
        </BRow>

      </BCard>


  </div>
</template>

<style src="spinkit/spinkit.min.css"></style> <!--animated processing icon-->
<style>
.v-scroll-button {
  background-color: #888 !important;
  display: block !important;
  width: 12px;
  border-radius: 6px;
}

.v-scroll-button .runner {
  display: block !important;
}

.vue-excel-editor .table-content .systable .center-text .table-col-header {
  pointer-events: none;
}
</style>

<script>

//-------------------------------------------------------------------------------------------------
import '@/common/HelperMixin';
import {
  apiCall,
} from '@/common/utils';
import TankTableList from '../components/TankTableList'
import OilTempTable from '../components/OilTempTable'
// import store from "@/store";
// import qs from 'querystring';
// import moment from "moment";




//----------------------------------------------------------------------------------------------------
export default {
  name: "Oil",
  components: {
    OilTempTable,
    TankTableList,
  },

  computed: {},

  watch: {
    /**
     * 탱크명 표시값 갱신.
     *
     * 종전에는 changeTid()에서 tankMap[tid].name을 바로 읽었다.
     * changeTid()는 탱크/상태 두 셀렉트에 함께 걸려 있어 탱크 미선택 상태(tid='')로
     * 상태를 바꾸거나 '탱크 선택'을 고르면 tankMap['']이 undefined라 예외가 났다.
     * 탱크명은 tid 변화에만 반응하면 되므로 여기로 옮기고 미선택은 빈 값으로 둔다.
     */
    tid(tid){
      this.tnm = this.tankMap?.[tid]?.name || '';
    }
  },

  data () {
    return {
      tableKey: 0,
      oilTempKey: 100000,
      tankOpts: [],
      tankMap: null,
      tid: '',
      tnm: '',
      selectedStatus: 1,
      groupIndex: null,
      statusOpts: [
        {value:1, label:'현재값'},
        {value:2, label:'이전값-2'},
        {value:3, label:'이전값-3'},
        {value:4, label:'이전값-4'},
        {value:5, label:'이전값-5'}
      ],
    }

  },
  async created(){
    try{
      await this.getTankOptions();
      // console.log('created()---------tank-table---------', this.tanks)
    }catch(err){
      console.log(err);
    }
  },


  mounted() {
    console.log("--- tank-table mounted---------------------");
    // below is not work!
  },

  methods: {
    changeTid(){
      this.tableKey++;
      this.$refs.oilTempTable.clearTable();
    },

    async getOilTempTable(){
      const tank = this.tankMap?.[this.tid];
      if( !tank ){
        return await this.alertWarn('탱크 정보를 찾을 수 없습니다. 탱크를 다시 선택해 주세요.');
      }

      // 탱크의 유종에 체적환산 그룹이 지정되어 있어야 환산표를 찾을 수 있다
      const oil = this.$store.state.codeMaps.OIL?.[tank.oilCode];
      if( !oil ){
        return await this.alertWarn(`[${tank.oilCode}] 유종의 체적환산 그룹 정보가 없습니다.`);
      }

      this.groupIndex = oil.oilTempGroup;
      this.oilTempKey++;
    },

    async refreshPage() {
      this.tid = '';
      this.tableKey = 0;
      await this.getTankOptions();
    },

    async getTankOptions(){
      try{
        const {result} = await apiCall('get', `/api/tank/init`);
        if(result) {
          this.$store.state.tanks['map'] = result.map;
          this.$store.state.tanks['opts'] = result.opts;
          this.$store.state.tanks['codes'] = result.codes;

          this.tankOpts = result.opts;
          this.tankMap = result.map;

          // console.log( "getTankOptions---------", this.tankMap );
        }

      }catch(err){
        console.log(err);
      }

    },

  }
}
</script>
